import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { appLogin } from '_api/lbl'
import store from '@/store'
import { Toast } from 'vant'
import setCrmDicRoutes from '_u/serverConfig'
import { pageTrack } from '_u/eventTrack'

const BASE_URL = process.env.BASE_URL.slice(1, -1).replace(/app$/, '')
const routes = require(`./${BASE_URL}.js`).default

// 开发环境中同步路由字典
if (process.env.NODE_ENV === 'development' && BASE_URL === 'sev') {
  setCrmDicRoutes()
}

routes.push({
  path: '*',
  name: 'error',
  component: () => import('@/views/404'),
  props: route => route.query,
  meta: {
    title: '错误页面'
  }
})

// 规避重复路由错误
const routerPush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => err)
}
const routerReplace = Router.prototype.replace
Router.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch(err => err)
}

Vue.use(Router).use(Meta, {
  refreshOnceOnNavigation: true
})

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 500)
      })
    }
  },
  base: `/${BASE_URL}${BASE_URL === 'crm' ? '/' : 'app/'}`,
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (BASE_URL === 'sev') {
    if (to.query.souce) {
      if (!from.name) store.commit('RESET')
      if (to.query.sid) store.commit('SET_SID', to.query.sid)
      store.commit('SET_SOUCE', Number(to.query.souce))
      store.commit('SET_ENTRANCE', to.name)
    }
    // 保存入口页路径
    if (!from.name) {
      store.commit('SET_ENTRANCEHREF', location.href)
    }
    // 只有在商城H5 会有入参 判断扫一扫功能是否可以使用
    if (to.query.v) store.commit('SET_APPV', to.query.v)
    // 手机刘海屏高度---APP让出导航栏才需要传
    console.log('toH', to.query.h)
    if (to.query.h) store.commit('SET_APPH', to.query.h)
    // 增加判断 appToken是否一致
    const theSameToken = store.state.sev.appToken === to.query.token
    // 来源为APP 且有token存在 并且token和已存储的token不一致
    if ((['1'].includes(to.query.souce) && to.query.token && !theSameToken) || to.query.app) {
      // App入口需要获取新的token
      store.commit('SET_APPTOKEN', to.query.token)
      Toast({
        message: '页面加载中',
        forbidClick: true,
        duration: 0,
        className: 'sev-loading',
        icon: 'circle'
      })
      const res = await appLogin()
      if (res.code === 1) {
        store.commit('SET_SID', res.data.sid)
        next()
      } else next('/404?text=未识别用户信息')
      Toast.clear()
    } else next()
  } else {
    if (from.query.token) {
      to.query.token = from.query.token
    }
    next()
  }
})

router.afterEach((to, from) => {
  if (BASE_URL === 'sev') {
    // 进入上报
    pageTrack(1, to)
    // 退出上报
    pageTrack(0, from)
  }
})
export default router
